import React from "react"
import Button from "@kit/design/button"
import Note from "@kit/design/note"
import Container from "core/container"
import useFetch from "hooks/use-new-fetch"

export default function TemplateShow({ id, name, creator, content }) {
  const [request, loading, status] = useFetch(`/editor/templates/${id}/clone`)

  const btnDisabled = loading || status === "success"

  const cloneTemplate = async () => {
    await request.post()
  }

  return (
    <div className="w-full bg-gray-100">
      <Container className="flex flex-col lg:flex-row gap-6 lg:gap-12 py-8 items-start">
        <aside className="lg:order-2 lg:max-w-xs flex flex-col gap-4 py-8 lg:py-10">
          <h1 className="m-0 font-semibold text-2xl leading-normal">{name}</h1>
          <p className="m-0 text-base">
            {creator} has shared this email template for you to use.
          </p>
          <div className="lg:pt-4 flex items-center gap-4">
            <Button disabled={btnDisabled} is="primary" onClick={cloneTemplate}>
              {loading ? "Copying template..." : "Use this template"}
            </Button>
            <KitBadge />
          </div>
          {status === "success" && (
            <Note
              type="success"
              title="Success!"
              message="You are being redirected as we copy this template to your account. If you are not signed in, you will be prompted to sign in."
            />
          )}
          {status === "error" && (
            <Note
              type="error"
              title="Uh oh, something isn't quite right"
              message="We were unable to copy this template to your account. Please try again"
            />
          )}
        </aside>

        <main
          className="lg:flex-1 rounded-lg shadow-lg overflow-auto pointer-events-none"
          aria-label="Email template content"
        >
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </main>
      </Container>
    </div>
  )
}

const KitBadge = () => (
  <div className="flex items-center gap-2">
    <div
      className="font-semibold tracking-wider uppercase"
      style={{ fontSize: 10 }}
    >
      with
    </div>
    <svg
      width="50"
      viewBox="0 0 400 181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M109.562 75.1422c49.21 9.535 64.488 55.0968 64.903 100.9298 0 1.03-.831 1.878-1.86 1.878h-61.959c-1.03 0-1.86-.83-1.86-1.842-.181-35.557-5.942-66.925-41.1743-68.28-1.0474-.036-1.9322.795-1.9322 1.86v66.42c0 1.03-.8307 1.86-1.8601 1.86H1.86a1.857 1.857 0 0 1-1.86-1.86V6.8262c0-1.0294.8307-1.86 1.86-1.86h61.9775c1.0293 0 1.86.8306 1.86 1.86v63.4041c0 .939.7585 1.6975 1.6975 1.6975.7404 0 1.4086-.4876 1.6253-1.1919C84.9661 18.4379 114.781 5.2912 163.196 4.9842c1.03 0 1.86.8307 1.86 1.86v63.2416c0 1.0293-.83 1.86-1.86 1.86h-53.327c-.903 0-1.625.7224-1.625 1.6253 0 .7585.56 1.4266 1.318 1.5711Zm169.661 39.6388V73.7878c0-1.0293.831-1.86 1.861-1.86h45.598c.903 0 1.625-.7224 1.625-1.6253 0-.7765-.56-1.4447-1.318-1.5892-35.684-7.079-52.154-27.6117-52.714-61.8871-.018-1.0113.795-1.86 1.824-1.86h66.962c1.029 0 1.86.8306 1.86 1.86V35.702c0 1.0294.831 1.8601 1.86 1.8601h38.393c1.029 0 1.86.8307 1.86 1.86v30.6817c0 1.0294-.831 1.8601-1.86 1.8601h-38.393c-1.029 0-1.86.8307-1.86 1.86v33.0651c0 11.684 7.169 15.531 16.686 15.531 14.917 0 29.653-6.718 35.558-9.77 1.228-.632 2.709.253 2.709 1.643v51.468c0 1.372-.759 2.636-1.969 3.286-5.833 3.07-23.855 11.576-44.46 11.576-42.456-.036-74.222-17.318-74.222-65.842Zm-87.169 61.309V73.7878c0-1.0293.831-1.86 1.86-1.86h61.978c1.029 0 1.86.8307 1.86 1.86V176.09c0 1.03-.831 1.86-1.86 1.86h-61.978c-1.029-.018-1.86-.848-1.86-1.86Zm-3.521-144.5595c0 17.4086 12.298 31.5305 35.918 31.5305 23.621 0 35.919-14.1219 35.919-31.5305S248.09 0 224.451 0c-23.62 0-35.918 14.1219-35.918 31.5305Z"
          fill="#000"
        />
      </g>
    </svg>
  </div>
)
